// source: pbtypes/gen/vehicle_params_for_phone/camera_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_calibration_camera_rig_pb = require('../../../pbtypes/gen/calibration/camera_rig_pb.js');
goog.object.extend(proto, pbtypes_gen_calibration_camera_rig_pb);
goog.exportSymbol('proto.vehicle_params_for_phone.CameraParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_params_for_phone.CameraParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vehicle_params_for_phone.CameraParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_params_for_phone.CameraParams.displayName = 'proto.vehicle_params_for_phone.CameraParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_params_for_phone.CameraParams.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_params_for_phone.CameraParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_params_for_phone.CameraParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.CameraParams.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
cameraIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
cameraRig: (f = msg.getCameraRig()) && pbtypes_gen_calibration_camera_rig_pb.CameraRig.toObject(includeInstance, f),
streamFps: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_params_for_phone.CameraParams}
 */
proto.vehicle_params_for_phone.CameraParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_params_for_phone.CameraParams;
  return proto.vehicle_params_for_phone.CameraParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_params_for_phone.CameraParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_params_for_phone.CameraParams}
 */
proto.vehicle_params_for_phone.CameraParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setCameraIndex(value);
      break;
    case 3:
      var value = new pbtypes_gen_calibration_camera_rig_pb.CameraRig;
      reader.readMessage(value,pbtypes_gen_calibration_camera_rig_pb.CameraRig.deserializeBinaryFromReader);
      msg.setCameraRig(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setStreamFps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_params_for_phone.CameraParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_params_for_phone.CameraParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_params_for_phone.CameraParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.CameraParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCameraIndex();
  if (f !== 0) {
    writer.writeSint32(
      2,
      f
    );
  }
  f = message.getCameraRig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_calibration_camera_rig_pb.CameraRig.serializeBinaryToWriter
    );
  }
  f = message.getStreamFps();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.CameraParams.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.CameraParams} returns this
 */
proto.vehicle_params_for_phone.CameraParams.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional sint32 camera_index = 2;
 * @return {number}
 */
proto.vehicle_params_for_phone.CameraParams.prototype.getCameraIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.CameraParams} returns this
 */
proto.vehicle_params_for_phone.CameraParams.prototype.setCameraIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional calibration.CameraRig camera_rig = 3;
 * @return {?proto.calibration.CameraRig}
 */
proto.vehicle_params_for_phone.CameraParams.prototype.getCameraRig = function() {
  return /** @type{?proto.calibration.CameraRig} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_calibration_camera_rig_pb.CameraRig, 3));
};


/**
 * @param {?proto.calibration.CameraRig|undefined} value
 * @return {!proto.vehicle_params_for_phone.CameraParams} returns this
*/
proto.vehicle_params_for_phone.CameraParams.prototype.setCameraRig = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.CameraParams} returns this
 */
proto.vehicle_params_for_phone.CameraParams.prototype.clearCameraRig = function() {
  return this.setCameraRig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.CameraParams.prototype.hasCameraRig = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float stream_fps = 4;
 * @return {number}
 */
proto.vehicle_params_for_phone.CameraParams.prototype.getStreamFps = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.CameraParams} returns this
 */
proto.vehicle_params_for_phone.CameraParams.prototype.setStreamFps = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


goog.object.extend(exports, proto.vehicle_params_for_phone);
